const STATUS_STYLE = {
  verified: { bg: "#dcfce7", color: "#166534", label: "Verified" },
  mismatch: { bg: "#fee2e2", color: "#991b1b", label: "Mismatch" },
  not_verified: { bg: "#f3f4f6", color: "#4b5563", label: "Not Verified" },
};

export const GuardianBadge = ({ status, count }) => {
  const style = STATUS_STYLE[status] || STATUS_STYLE.not_verified;
  return (
    <span
      data-testid={`guardian-badge-${status}`}
      style={{
        background: style.bg,
        color: style.color,
        borderRadius: "999px",
        fontSize: "0.72rem",
        fontWeight: 700,
        padding: "0.15rem 0.55rem",
        display: "inline-flex",
        alignItems: "center",
        gap: "0.3rem",
        whiteSpace: "nowrap",
      }}
    >
      {style.label}
      {typeof count === "number" && <strong>{count}</strong>}
    </span>
  );
};

export default GuardianBadge;
